import { useGetAccountPaymentMethods } from '@cocoonspace/sdk-js/domains/account/account'

export const useWallet = () => {
	return useGetAccountPaymentMethods({
		query: {
			select: (res) => {
				const pm = res.data.find((pm) => pm.type === 'wallet')

				if (!pm) return undefined

				return {
					id: pm?.id,
					// @ts-ignore
					amount: (pm?.wallet.amount as number) || 0,
				}
			},
		},
	})
}
